<div class="row">
  <div class="col col-12">
    <app-header />
  </div>
</div>

<div tuiCardLarge tuiSurface="elevated">
  <div class="row">
    <div class="col col-12">
      <div tuiHeader>
        <h1>Tableau de bord</h1>
      </div>
    </div>
  </div>
  <div class="row pageList">
    <div
      tuiCardMedium
      tuiSurface="flat"
      class="tout"
      routerLink="/patient/list"
    >
      <div class="row">
        <div class="col col-12">
          <tui-avatar-stack direction="left">
            <tui-avatar
              size="s"
              src="https://i.pravatar.cc/150?u=1"
              [style.background]=""
            />
            <tui-avatar
              size="s"
              src="https://i.pravatar.cc/150?u=2"
              [style.background]=""
            />
            <tui-avatar
              size="s"
              src="https://i.pravatar.cc/150?u=3"
              [style.background]=""
            />
          </tui-avatar-stack>

          <h2>Patients</h2>
        </div>
      </div>
    </div>
    <div
      tuiCardMedium
      tuiSurface="flat"
      class="prescription-form"
      routerLink="/prescription-form/list"
    >
      <div class="row">
        <div class="col col-12">
          <tui-avatar-stack direction="left">
            <tui-avatar size="s" src="@tui.files" [style.background]="" />
            <tui-avatar size="s" src="@tui.files" [style.background]="" />
            <tui-avatar size="s" src="@tui.files" [style.background]="" />
            <tui-avatar size="s" src="@tui.files" [style.background]="" />
            <tui-avatar size="s" src="@tui.files" [style.background]="" />
            <tui-avatar size="s" src="@tui.files" [style.background]="" />
          </tui-avatar-stack>

          <h2>Prescriptions</h2>
        </div>
      </div>
    </div>
    @if (
      user?.role?.slug != "super-admin" &&
      user?.role?.slug != "admin" &&
      user?.role?.slug != "mini-admin" &&
      user?.role?.slug != "apporteur"
    ) {
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="echues"
        [routerLink]="[]"
        (click)="navigateToPatientList(0)"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              @if (nombrePrescriptionsEchues0() !== undefined) {
                <tui-avatar size="s" [style.background]="">
                  {{ nombrePrescriptionsEchues0() }}
                </tui-avatar>
              } @else {
                <tui-avatar size="s" [style.background]="" class="placeholder">
                  XX
                </tui-avatar>
              }
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=4"
                [style.background]=""
              />
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=5"
                [style.background]=""
              />
            </tui-avatar-stack>

            <h2>Prescriptions échues</h2>
          </div>
        </div>
      </div>
    }

    @if (
      user?.role?.slug != "super-admin" &&
      user?.role?.slug != "admin" &&
      user?.role?.slug != "mini-admin" &&
      user?.role?.slug != "apporteur"
    ) {
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="echues-1-mois"
        [routerLink]="[]"
        (click)="navigateToPatientList(1)"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              @if (nombrePrescriptionsEchues1mois0() !== undefined) {
                <tui-avatar size="s" [style.background]="">
                  {{ nombrePrescriptionsEchues1mois0() }}
                </tui-avatar>
              } @else {
                <tui-avatar size="s" [style.background]="" class="placeholder">
                  XX
                </tui-avatar>
              }
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=6"
                [style.background]=""
              />
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=7"
                [style.background]=""
              />
            </tui-avatar-stack>

            <h2>Prescriptions échues sous 1 mois</h2>
          </div>
        </div>
      </div>
    }

    @if (
      user?.role?.slug != "super-admin" &&
      user?.role?.slug != "admin" &&
      user?.role?.slug != "mini-admin" &&
      user?.role?.slug != "apporteur"
    ) {
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="echues-2-mois"
        [routerLink]="[]"
        (click)="navigateToPatientList(2)"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              @if (nombrePrescriptionsEchues2mois0() !== undefined) {
                <tui-avatar size="s" [style.background]="">
                  {{ nombrePrescriptionsEchues2mois0() }}
                </tui-avatar>
              } @else {
                <tui-avatar size="s" [style.background]="" class="placeholder">
                  XX
                </tui-avatar>
              }
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=8"
                [style.background]=""
              />
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=9"
                [style.background]=""
              />
            </tui-avatar-stack>

            <h2>Prescriptions échues sous 2 mois</h2>
          </div>
        </div>
      </div>
    }

    @if (
      user?.role?.slug != "super-admin" &&
      user?.role?.slug != "admin" &&
      user?.role?.slug != "mini-admin" &&
      user?.role?.slug != "apporteur"
    ) {
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="initiale-a-valider"
        [routerLink]="[]"
        (click)="navigateToPatientList(3)"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              @if (nombrePrescriptionsInitiales0() !== undefined) {
                <tui-avatar size="s" [style.background]="">
                  {{ nombrePrescriptionsInitiales0() }}
                </tui-avatar>
              } @else {
                <tui-avatar size="s" [style.background]="" class="placeholder">
                  XX
                </tui-avatar>
              }
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=10"
                [style.background]=""
              />
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=11"
                [style.background]=""
              />
            </tui-avatar-stack>

            <h2>Prescriptions initiale à valider</h2>
          </div>
        </div>
      </div>
    }
    @if (
      user?.role?.slug == "super-admin" ||
      user?.role?.slug == "admin" ||
      (authService.user?.autorisations?.get("read")?.length ?? 0) > 1
    ) {
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="tout"
        routerLink="/medecin/list"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=12"
                [style.background]=""
              />
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=13"
                [style.background]=""
              />
              <tui-avatar
                size="s"
                src="https://i.pravatar.cc/150?u=14"
                [style.background]=""
              />
            </tui-avatar-stack>

            <h2>Médecins</h2>
          </div>
        </div>
      </div>
    }
    <div
      tuiCardMedium
      tuiSurface="flat"
      class="demande-contact"
      (click)="openDemandeContactModal()"
    >
      <div class="row">
        <div class="col col-12">
          <tui-avatar-stack direction="left">
            <tui-avatar size="s" src="@tui.message-circle" [style.background]="" />
          </tui-avatar-stack>

          <h2>Demandes de contact</h2>
        </div>
      </div>
    </div>
    @if (user?.role?.slug == "super-admin") {
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="maintenance"
        routerLink="message-maintenance"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar
                size="s"
                src="@tui.circle-slash-2"
                [style.background]=""
              />
            </tui-avatar-stack>

            <h2>Mode maintenance</h2>
          </div>
        </div>
      </div>
    }
  </div>
</div>
@if (
  user?.role?.slug == "super-admin" ||
  user?.role?.slug == "admin" ||
  user?.role?.slug == "hospitalier" ||
  user?.role?.slug == "liberal" ||
  (authService.user?.autorisations?.get("prescribe")?.length ?? 0) > 1
) {
  <div tuiCardLarge tuiSurface="elevated">
    <div class="row">
      <div class="col col-12">
        <div tuiHeader>
          <h1>Nouveau patient</h1>
        </div>
      </div>
    </div>
    <div class="row pageList">
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="NEW-PPC"
        (click)="openForm('PPC')"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar size="s" src="@tui.plus" [style.background]="" />
            </tui-avatar-stack>

            <h2>PPC</h2>
          </div>
        </div>
      </div>
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="NEW-VENTILATION"
        (click)="openForm('VENTILATION')"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar size="s" src="@tui.plus" [style.background]="" />
            </tui-avatar-stack>

            <h2>Ventilation</h2>
          </div>
        </div>
      </div>
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="NEW-O2"
        (click)="openForm('O2')"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar size="s" src="@tui.plus" [style.background]="" />
            </tui-avatar-stack>

            <h2>Oxygéno-thérapie</h2>
          </div>
        </div>
      </div>
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="NEW-AVF"
        (click)="openForm('AVF')"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar size="s" src="@tui.plus" [style.background]="" />
            </tui-avatar-stack>

            <h2>AVF</h2>
          </div>
        </div>
      </div>
      <div
        tuiCardMedium
        tuiSurface="flat"
        class="NEW-AEROSOLS"
        (click)="openForm('AEROSOLS')"
      >
        <div class="row">
          <div class="col col-12">
            <tui-avatar-stack direction="left">
              <tui-avatar size="s" src="@tui.plus" [style.background]="" />
            </tui-avatar-stack>

            <h2>Aérosols</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
}
